import React from "react";
import { Typography } from "@mui/material";

const NotFound = () => {
  return (
    <div>
      <Typography variant="h5">Not Found / Non trouvé</Typography>
    </div>
  );
};

export default NotFound;
